import { lazy } from "react";
import { PermissionGuard, PermissionEnum } from "@/modules/authentication";

const Dhcs = lazy(() => import("./Dhcs"));
const DhcLayout = lazy(() => import("../layouts"));
const Overview = lazy(() => import("./Overview"));
const Clients = lazy(() => import("./Clients"));

const Routes = () => {
	const baseUrl = "/dhcs";

	return [
		{
			path: baseUrl,
			element: (
				<PermissionGuard permission={PermissionEnum.DhcRead}>
					<Dhcs />
				</PermissionGuard>
			),
		},
		{
			path: `${baseUrl}/:dhcId`,
			element: (
				<PermissionGuard permission={PermissionEnum.DhcRead}>
					<DhcLayout />
				</PermissionGuard>
			),
			children: [
				{
					path: "",
					element: <Overview />,
				},
				{
					path: "clients",
					element: <Clients />,
				},
			],
		},
	];
};

export { Routes };
